<template>
  <div>
    <div
      :class="[
        'v-input datetime-field theme--light v-text-field v-text-field--enclosed v-text-field--outlined',
        {
          'v-input--is-disabled': disabled,
          'v-input--is-readonly': readonly,
          'error--text': errorMessages,
        },
      ]"
    >
      <div class="v-input__control">
        <div class="v-input__slot">
          <fieldset>
            <legend>
              <span>&#8203;</span>
            </legend>
          </fieldset>
          <div class="v-text-field__slot">
            <label
              :for="inputId"
              :class="[
                'v-label theme--light',
                {
                  'error--text': errorMessages,
                },
              ]"
              style="left: auto;right: 0px;position: absolute"
            >{{ label }}</label>
            <input
              :id="inputId"
              v-validate="validates"
              class="datetime-input"
              :disabled="disabled || readonly"
              :clearable="clearable"
              :data-vv-name="id"
              :data-vv-as="dataVvAs"
              readonly
              @input="
                updateValue($event);
                $emit('input', $event);
              "
              @change="
                updateValue($event);
                $emit('change', $event);
              "
            >
            <v-icon class="icon">
              mdi-calendar
            </v-icon>
          </div>
        </div>
        <div class="v-text-field__details">
          <div class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              {{ errorMessages }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/libs/calendars/jquery.plugin.js';
import '@/libs/calendars/jquery.calendars.js';
import '@/libs/calendars/jquery.calendars-ar-EG.js';
import '@/libs/calendars/jquery.calendars.plus.js';
import '@/libs/calendars/jquery.calendars.picker.js';
import '@/libs/calendars/jquery.calendars.picker-ar.js';
import '@/libs/calendars/jquery.calendars.ummalqura.js';
import '@/libs/calendars/jquery.calendars.ummalqura-ar.js';
import '@/libs/calendars/jquery.calendars.picker.css';
import '@/libs/calendars/smoothness.calendars.picker.css';

export default {
  inject: ['$validator'],
  props: {
    id: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: 'ar-SA',
    },
    dataVvAs: { type: String },
    errorMessages: { type: String },
    value: { required: true },
    label: { required: false },
    disabled: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    validates: { required: false },
    max: { type: String },
    min: { type: String },
  },
  data() {
    return {
      minYear: '1860',
      maxYear: new Date()
        .getFullYear() + 50,
    };
  },
  computed: {
    isHijri() {
      return this.locale === 'ar-SA';
    },
    calendarName() {
      return this.isHijri ? 'ummalqura' : 'gregorian';
    },
    hijriInputId() {
      return `${this.id}-hijri`;
    },
    gregorianInputId() {
      return `${this.id}-gregorian`;
    },
    inputId() {
      return `${this.isHijri ? this.hijriInputId : this.gregorianInputId}`;
    },
  },
  watch: {
    min() {
      this.init();
    },
    max() {
      this.init();
    },
    disabled(value) {
      value
        ? $(this.inputSelector)
          .calendarsPicker('disable')
        : $(this.inputSelector)
          .calendarsPicker('enable');
    },
    readonly(value) {
      value
        ? $(this.inputSelector)
          .calendarsPicker('disable')
        : $(this.inputSelector)
          .calendarsPicker('enable');
    },
    value(newVal) {
      this.updateDatepicker(newVal);
    },
  },
  mounted() {
    this.init();

    this.updateDatepicker(this.value);
  },
  methods: {
    init() {
      // input
      this.inputSelector = `#${this.inputId}`;

      // destory any active instance
      $(this.inputSelector)
        .calendarsPicker('destroy');

      // main Configs
      const initConfigs = [this.calendarName, this.isHijri ? 'ar' : 'ar-EG'];

      // calendars
      this.Calendar = $.calendars.instance(...initConfigs);

      var currentDate = new Date();
      var maxDate = this.getCalendarJD(this.max || `${this.maxYear}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`);
      var minDate = this.getCalendarJD(this.min || `${this.minYear}-1-1`);

      $(this.inputSelector)
        .calendarsPicker({
          firstDay: 6,
          isRTL: true,
          maxDate,
          minDate,
          yearRange: `${minDate.year()}:${maxDate.year()}`, // 1900 in Gregorian is equal 1318 in Hijri
          calendar: this.Calendar,
          onSelect: (date) => {
            const jd = date[0] ? date[0].toJD() : date;
            const value = date[0] // check if date array is not empty
              ? $.calendars
                .instance(this.calendarName)
                .fromJD(jd)
                .toString()
              : null;

            const hijriDate = this.isHijri ? date : this.getHijriDateObject(value);
            const gregorianDate = this.isHijri ? this.getGregorianDateObject(value) : date;

            $(`#${this.hijriInputId}`)
              .calendarsPicker('setDate', hijriDate)
              .calendarsPicker('option', { dateFormat: 'yyyy-mm-dd' }) // set Hijri Date By jQuery Based On Calendars Date Instance
              .blur();
            $(`#${this.gregorianInputId}`)
              .calendarsPicker('setDate', gregorianDate)
              .calendarsPicker('option', { dateFormat: 'yyyy-mm-dd' }) // set Gregorian Date By jQuery Based On Calendars Date Instance
              .blur();
            this.updateValue(this.getGregorianDateString(gregorianDate)); // update The Calendar Logic Only Not The Input Value
          },
        });
    },
    updateValue(value) {
      this.$emit('change', value);
    },
    getGregorianDateString(date) {
      if (!date[0]) return null; // return null if date is empty array

      return $.calendars
        .instance('gregorian')
        .fromJD(date[0].toJD())
        .toString();
    },
    getGregorianDateObject(hijriDate) {
      if (!hijriDate) return []; // return empty array if date == null
      const dateInstance = hijriDate.split('-')
        .map(item => Number(item));

      const jd = $.calendars
        .instance('ummalqura')
        .newDate(...dateInstance)
        .toJD();

      const date = $.calendars.instance('gregorian')
        .fromJD(jd);

      return [date];
    },
    getHijriDateObject(gregorianDate) {
      if (!gregorianDate) return []; // return empty array if date == null
      const dateInstance = gregorianDate.split('-')
        .map(item => Number(item));

      const jd = $.calendars
        .instance('gregorian')
        .newDate(...dateInstance)
        .toJD();

      const date = $.calendars.instance('ummalqura')
        .fromJD(jd); // return The Date Instance Not String

      return [date];
    },
    getCalendarJD(date) {
      if (!date || !date.length) return [];
      const dateInstance = date.split('-')
        .map(item => Number(item));
      const jd = $.calendars
        .instance()
        .newDate(...dateInstance)
        .toJD();

      return $.calendars.instance(this.calendarName)
        .fromJD(jd); // return The Date Instance Not String
    },
    updateCalendarValue(date) {
      const inputId = this.isHijri ? this.hijriInputId : this.gregorianInputId;
      this.setCalendarDate(inputId, date);
      this.$validator.errors.remove(this.id);
    },
    setCalendarDate(inputId, date) {
      $(`#${inputId}`)
        .calendarsPicker('setDate', [].concat(this.getCalendarJD(date)))
        .calendarsPicker('option', { dateFormat: this.isHijri ? 'yyyy-mm-dd' : 'yyyy-mm-dd' })
        .blur();
    },
    resetCalendarValues() {
      this.setCalendarDate(this.hijriInputId, []);
      this.setCalendarDate(this.gregorianInputId, []);
    },
    updateDatepicker(date) {
      !date ? this.resetCalendarValues() : this.updateCalendarValue(date);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/partials/_fonts.scss";
.v-input {
  margin-top: 0;
  .v-text-field__slot {
    position: relative;
    .datetime-input {
      position: relative;
      z-index: 2;
      padding-left: 25px;
    }
    .icon {
      position: absolute;
      left: 0;
      color: #9e9e9e;
    }
  }
}
.calendars-popup {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  transform: scale(1.3);
  margin-top: 34px;
  margin-left: -25px;

  .calendars {
    font-family: $mainFont;
    border: 0;

    .calendars-nav {
      background-color: #009587;
      display: flex;
      justify-content: space-between;
      padding: 5px;

      a {
        color: #fff;

        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }

    .calendars-ctrl {
      background-color: #fff;
      padding: 5px;

      a:hover {
        background-color: rgba(0, 0, 0, 0.1);
        color: #009587;
      }
    }

    .calendars-month-row {
      display: flex;
      .calendars-month {
        border: 0;
        flex: 1;

        .calendars-month-header {
          background-color: #009587;
          height: auto;
          padding: 5px;

          .calendars-month-year {
            background-color: transparent;
            color: #fff;
            font-size: 16px;
            option {
              color: #009587;
            }
          }
        }

        table {
          thead {
            border: 0;
            tr {
              border: 0;
              th {
                background-color: #fff;
                border: 0;
                color: rgba(0, 0, 0, 0.38);
                font-weight: bold;
              }
            }
          }
          tbody {
            tr {
              border: 0;
              td {
                font-size: 14px;
                border: 0;
                background-color: #fff;

                a {
                  &:hover {
                    color: #009587;
                  }

                  &.calendars-today {
                    border: 1px solid #009587;
                    color: #009587;
                  }
                  &.calendars-selected {
                    background-color: #009587;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
